import { useTranslation } from 'react-i18next'
import { FormControlLabelProps, RadioGroupProps, RadioProps, TypographyProps } from '@mui/material'
import FormControlLabel from '@mui/material/FormControlLabel'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import Typography from '@mui/material/Typography'
import { useFormikContext } from 'formik'
import { TranslationsKeys } from 'utils/createTranslationKey'

export interface ControlLabel<T = unknown> extends Partial<FormControlLabelProps> {
  label: TranslationsKeys
  value: T
}
export interface FormikRadioGroupProps extends RadioGroupProps {
  name: string
  controlsProps?: RadioProps
  controlLabels: ControlLabel[]
  labelProps?: TypographyProps<'span', {}> | undefined
  disabled?: boolean
  errorProps?: TypographyProps<'span', {}> | undefined
}

export const FormikRadioGroup = ({
  name,
  controlsProps = { color: 'primary' },
  controlLabels = [],
  onChange,
  labelProps,
  disabled,
  errorProps,
  ...props
}: FormikRadioGroupProps) => {
  const { t } = useTranslation()
  const { getFieldMeta, setFieldValue } = useFormikContext()
  const { error, touched, value } = getFieldMeta(name)

  return (
    <>
      <RadioGroup
        value={value}
        name={name}
        onChange={onChange || ((_, value) => setFieldValue(name, Number(value)))}
        {...props}
      >
        {controlLabels?.map(({ value, label, ...elProps }, i) => (
          <FormControlLabel
            control={<Radio {...controlsProps} />}
            label={
              <Typography variant="h3" fontWeight="bold" sx={{ mr: 3 }} {...labelProps}>
                {t(label)}
              </Typography>
            }
            value={value}
            key={i}
            slotProps={{
              typography: labelProps,
            }}
            disabled={disabled}
            {...elProps}
          />
        ))}
      </RadioGroup>
      {touched && error && (
        <Typography color="error" {...errorProps}>
          {error}
        </Typography>
      )}
    </>
  )
}
